/**
 * Created by denis.gusarov on 3/7/2017.
 */
namespace Factive.Core {
    import _ = Factive.Core.Underscore;

    export class CompactIOC {

        private cache: any;
        private factories: any;

        constructor() {
            this.factories = {};
            this.cache = {};
        }
        pub(name, factory) {
            this.factories[name] = factory;
            //console.error("IOC register factory for '" + name + "'");
        }
        unpub(name) {
            delete this.factories[name];
            delete this.cache[name];
        }
        get(name, mocks = {}, options = null) {
            let factory = this.factories[name];

            if (!factory){
                _.each(Factive, function (value, key) {
                    if(key == name && value.factory){
                        if(value.factory){
                            if(!factory){
                                factory = value.factory;
                            }else{
                                console.error("IOC factory's dublicate for '" + name + "'");
                            }
                        }
                    }
                }, this);
                _.each(Factive.Game, function (value, key) {
                    if(key == name && value.factory){
                        if(value.factory){
                            if(!factory){
                                factory = value.factory;
                            }else{
                                console.error("IOC factory's dublicate for '" + name + "'");
                            }
                        }
                    }
                }, this);
                this.pub(name, factory);
                factory = this.factories[name];
                if (!factory){
                    console.error("IOC can't find factory for '" + name + "'");
                    return false;
                }
            }

            //factory.DependenciesContainer = this.factories["DependenciesContainer"].call({});

            if (!Array.isArray(factory.dependency)) return this.cache[name] = factory.call({});

            if (this.cache[name] && options == null) {
                return this.cache[name];
            }
            else {
                this.cache[name] = factory.get.apply({}, _.map(factory.dependency,(dep) =>
                {
                    if(dep == "Options"){
                        return options;
                    }
                    return mocks[dep] || this.cache[dep] || this.get(dep, mocks, null)
                }));
                this.cache[name]._dependenciesContainer = this.factories["DependenciesContainer"].call({});
                return this.cache[name];
            }
        }
        flush(name) {
            delete this.cache[name];
        }
    }
}



// WEBPACK FOOTER //
// src/typescript/Core/CompactIOC.ts